<template>
  <div>
    <template v-if="$vuetify.breakpoint.width >= 824">
      <v-slide-x-reverse-transition>
        <history-card
          v-if="currentShow === 'full'"
          v-on="$listeners"
          v-bind="$attrs"
          transition="slide-x-transition"
          :object="object"
          :entity="entity"
          :type-action="typeAction"
          :loading="loading"
        />
        <controls-parameters
          v-if="currentShow === 'controls-parameters-change'"
          v-on="$listeners"
          v-bind="$attrs"
          transition="slide-x-transition"
          :object="object"
          :entity="entity"
          :context="currentContext"
          :type-action="typeAction"
        />
      </v-slide-x-reverse-transition>
      <inner-card
        :entity="currentShow !== 'entity' ? nestedEntity : entity"
        v-bind="$attrs"
        v-on="$listeners"
        :loading="loading"
        :is-nested-entity="Boolean($route.query.nestedId || isNestedEntity)"
      />
    </template>
    <v-dialog
      :value="true"
      :fullscreen="true"
      scrollable
      v-else
      :no-click-animation="true"
      :persistent="true"
    >
      <v-card>
        <v-card-text class="pa-0">
          <keep-alive>
            <history-card
              v-if="currentShow === 'full'"
              v-on="$listeners"
              v-bind="$attrs"
              transition="slide-x-transition"
              :object="object"
              :entity="entity"
              :type-action="typeAction"
              :loading="loading"
            />
            <controls-parameters
              v-if="currentShow === 'controls-parameters-change'"
              v-on="$listeners"
              v-bind="$attrs"
              transition="slide-x-transition"
              :object="object"
              :entity="entity"
              :context="currentContext"
              :type-action="typeAction"
            />
          </keep-alive>
          <inner-card
            :entity="entity"
            v-bind="$attrs"
            v-on="$listeners"
            :is-nested-entity="Boolean($route.query.nestedId || isNestedEntity)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InnerCard from './InnerCard';
import HistoryCard from '@/components/history-card';
import ControlsParameters from '@/components/ControlsParameters';

export default {
  components: {
    ControlsParameters,
    HistoryCard,
    InnerCard
  },
  props: {
    entity: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    tabData: {
      type: Object,
      default: () => ({})
    },
    currentShow: {
      type: String,
      default: 'entity'
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    },
    currentContext: {
      type: [Object, String],
      default: () => ({})
    },
    typeAction: {
      type: String,
      default: ''
    },
    nestedEntity: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  }
};
</script>
